/* eslint-disable import/order */
import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';

// Lodash
import _size from 'lodash/size';
import _noop from 'lodash/noop';

// constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { OVERSCAN_ROW_COUNT, TABLE_STYLES } from './virtualizedInputTable.constants';

// builders
import ColumnConfig from '../../builders/ColumnConfig';

// Component
import { VariableSizeList as List } from 'react-window';
import VirtualizedInputTableRow from './molecules/virtualizedInputTableRow';
import VirtualizedInputTableInnerElementType from './molecules/virtualizedInputTableInnerElementType';

// context
import { InnerElementTypeProvider } from './context/innerElementType';

// hooks
import useRowHeight from './hooks/useRowHeight';

// helpers
import { getInnerElementTypeProps, getRowProps } from './virtualizedInputTable.helpers';
function VirtualizedInputTable(props) {
  var columns = props.columns,
    getTdProps = props.getTdProps,
    onAction = props.onAction,
    errors = props.errors,
    rowStyle = props.rowStyle,
    highlightRowOnFocus = props.highlightRowOnFocus,
    data = props.data,
    sortDetails = props.sortDetails,
    headerClassName = props.headerClassName,
    style = props.style,
    loading = props.loading;
  var tableHeight = style.height,
    tableWidth = style.width;
  var listRef = useRef();
  var _useRowHeight = useRowHeight(listRef),
    getRowHeight = _useRowHeight.getRowHeight,
    setRowHeight = _useRowHeight.setRowHeight;
  var rowProps = useMemo(function () {
    return getRowProps({
      errors: errors,
      columns: columns,
      getTdProps: getTdProps,
      onAction: onAction,
      rowStyle: rowStyle,
      highlightRowOnFocus: highlightRowOnFocus,
      data: data,
      setRowHeight: setRowHeight
    });
  }, [errors, columns, getTdProps, onAction, rowStyle, highlightRowOnFocus, data, setRowHeight]);
  var innerElementTypeProps = useMemo(function () {
    return getInnerElementTypeProps({
      columns: columns,
      onAction: onAction,
      sortDetails: sortDetails,
      headerClassName: headerClassName,
      data: data,
      loading: loading
    });
  }, [columns, onAction, sortDetails, headerClassName, data, loading]);
  return /*#__PURE__*/React.createElement(InnerElementTypeProvider, {
    value: innerElementTypeProps
  }, /*#__PURE__*/React.createElement(List, {
    style: TABLE_STYLES,
    height: tableHeight,
    itemCount: _size(data),
    itemSize: getRowHeight,
    itemData: rowProps,
    width: tableWidth,
    ref: listRef,
    overscanCount: OVERSCAN_ROW_COUNT,
    innerElementType: VirtualizedInputTableInnerElementType
  }, VirtualizedInputTableRow));
}
VirtualizedInputTable.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.arrayOf(PropTypes.instanceOf(ColumnConfig)),
  getTdProps: PropTypes.func,
  onAction: PropTypes.func,
  errors: PropTypes.array,
  rowStyle: PropTypes.object,
  highlightRowOnFocus: PropTypes.bool,
  sortDetails: PropTypes.object,
  headerClassName: PropTypes.string,
  style: PropTypes.shape({
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
  }),
  loading: PropTypes.bool
};
VirtualizedInputTable.defaultProps = {
  data: EMPTY_ARRAY,
  columns: EMPTY_ARRAY,
  errors: EMPTY_ARRAY,
  getTdProps: _noop,
  onAction: _noop,
  rowStyle: EMPTY_OBJECT,
  highlightRowOnFocus: false,
  sortDetails: EMPTY_OBJECT,
  headerClassName: undefined,
  style: EMPTY_OBJECT,
  loading: false
};
export default /*#__PURE__*/React.memo(VirtualizedInputTable);